import { CivilCase } from './../civil-case';
import { SafeJSON } from './../../shared/safe-json';

export class PartyAttorney {
    private json: any;
    private key: string;

    constructor(json: any, key: string) {
        this.json = json;
        this.key = key;
    }
    getKey(): string {
        return this.key;
    }
    getLastName(): string {
        let lastName: string = SafeJSON.get('attorney.name', this.json);
        // TAYLOR,CHRISTINA,MCALPIN

        let firstComma: number = lastName.indexOf(',');
        if (firstComma === 0) {
            // if there was no comma in the name, then just use the entire name we received.
            // TAYLOR
            firstComma = lastName.length - 1;
        }
        lastName = lastName.slice(0, firstComma);
        return lastName;
    }
    isAttorneyPrimary(): boolean {
        // this method is only used to determine if the attorney goes to the top of the list.
        // another method determines whether to display the primary indicator text.
        const indicator: string = SafeJSON.get('primaryIndicator', this.json);
        if (indicator === 'Y') {
            return true;
        }
        return false;
    }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/civil/civil-case-sections/party-attorney.ts